import { IGetAllProductsResult } from '../actions/get-all-products.action';

/**
 *
 * @param product the product to update
 * @param unitOfMeasure the unit to convert into
 * @param convertBackwards convert already converted value?
 * @returns
 */
export const getConversionFactor = (product: IGetAllProductsResult, unitOfMeasure: string, convertBackwards: boolean): number => {
    if (unitOfMeasure !== product.BaseUnit) {
        const alternativeUnit = product?.AlternativeUnits.find(unit => unit.Unit === unitOfMeasure);
        if (alternativeUnit) {
            return convertBackwards
                ? Number(alternativeUnit.Denomerator) / Number(alternativeUnit.Numerator)
                : Number(alternativeUnit.Numerator) / Number(alternativeUnit.Denomerator);
        }
    }
    return 1;
};
